import { useEffect, useState } from "react";
import { icons } from "../assets/icons";

const ThemeButton = () => {
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "dark" ? "light" : "dark"));
  };

  return (
    <button
      type="button"
      aria-label="Toggle theme"
      onClick={toggleTheme}
      className="text-2xl rounded-full p-2 
             bg-gray-200 dark:bg-gray-700 
             hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-600 dark:text-gray-200 
             transition-colors"
    >
      {theme === "dark" ? icons.moon : icons.sun}
    </button>
  );
};

export default ThemeButton;
